export const useChatStore = defineStore('chat', () => {
  const obs = useObsStore();
  const chatUrl = ref<string>();

  const isMainWindow = !!window.slabsGlobal;

  const setChatUrl = (url: string) => {
    chatUrl.value = url;

    if (isMainWindow) {
      const chatDock = obs.getDockByTitle('Streamlabs: Chat');
      // chatDock?.executeJavascript(`window.consumeChatUrl("${url}")`);
      // use window.location.href to avoid issues with the dock not being ready
      chatDock?.setUrl(url);
    }
  };

  return { chatUrl, setChatUrl };
});

// Stores are not kept in sync in docks
declare global {
  interface Window {
    consumeChatUrl: (chatUrl: string) => void;
  }
}

// TODO: would `window.postMessage` be worth it to avoid polluting globals?
export const onChatUrlChange = (cb: (chatUrl: string) => void) => {
  window.consumeChatUrl = async (chatUrl) => {
    await cb(chatUrl);
  };
};
